import styled from "styled-components";
import { device } from "../../../style/styled-components/helpers/device";
import ConsultRequest from "./ConsultRequest";
// 구성원 명함 카드. 마우스를 올리면 약력(history)을 보여준다. consult면 이 사람 앞 '상담 요청' 버튼을 단다.
const NameCard = ({
  member: {
    id = "",
    name = "",
    division = "",
    grade = "",
    tel = "",
    email = "",
    image = null,
    history = [],
  },
  unmaskContact = false,
  consult = false,
}) => {
  const mail = email ? email : `${id}@aonecustoms.com`;
  return (
    <Div $history={history?.length > 0}>
      <div className="text">
        <div className="title">
          <span className="name">{name}</span>
          <span className="grade">{grade}</span>
        </div>
        <div className="division">{division}</div>
        {unmaskContact && (
          <div className="contact">
            <a href={`tel:${tel}`}>
              <i aria-hidden="true">☎</i>
              {tel}
            </a>
            <a href={`mailto:${mail}`}>
              <i aria-hidden="true">✉</i>
              {mail}
            </a>
          </div>
        )}
        {history?.length > 0 && (
          <ul className="history">
            {history.map((x, idx) => {
              return <li key={idx}>{x}</li>;
            })}
          </ul>
        )}
        {consult && (
          <div className="consult">
            <ConsultRequest members={[{ id, email }]} expert={{ name, grade }} label="상담 요청" compact />
          </div>
        )}
      </div>
      {image && (
        <div className="photo">
          <Image src={image} alt="" />
        </div>
      )}
    </Div>
  );
};
export default NameCard;
const Div = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  max-width: 30rem;
  min-height: 14rem;
  box-sizing: border-box;
  border-radius: 1.25rem;
  border: 1px solid ${({ theme }) => theme.colors.line};
  background-color: white;
  box-shadow: ${({ theme }) => theme.shadow.sm};
  overflow: hidden;
  place-self: center;
  transition: background-color 0.3s, box-shadow 0.3s, border-color 0.3s;
  & > .text {
    position: relative;
    z-index: 1;
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    padding: 1.6rem 0 1.5rem 1.6rem;
    & > .title {
      display: flex;
      align-items: baseline;
      flex-wrap: wrap;
      gap: 0.25rem 0.6rem;
      & > .name {
        font-size: 1.6rem;
        font-weight: 800;
        letter-spacing: -0.02em;
        color: ${({ theme }) => theme.colors.dark};
      }
      & > .grade {
        font-size: 0.95rem;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.accent};
      }
    }
    & > .division {
      margin-top: 0.3rem;
      font-size: 0.9rem;
      color: ${({ theme }) => theme.colors.foreground.dimmed};
    }
    & > .contact {
      margin-top: auto;
      padding-top: 1.25rem;
      display: flex;
      flex-direction: column;
      gap: 0.35rem;
      font-size: 0.95rem;
      & > a {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
        color: ${({ theme }) => theme.colors.monotone.dark};
        word-break: break-all;
        & > i {
          font-style: normal;
          flex: 0 0 1.6rem;
          height: 1.6rem;
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 0.8rem;
          background-color: ${({ theme }) => theme.colors.accentSoft};
          color: ${({ theme }) => theme.colors.accent};
        }
        &:hover {
          color: ${({ theme }) => theme.colors.accent};
        }
      }
    }
    & > .history {
      display: none;
      margin: 1rem 0 0;
      padding: 0 0 0 1rem;
      font-size: 0.85rem;
      line-height: 1.6;
      /* 약력이 길어도 6줄 높이까지만 보이고 나머지는 스크롤(hover 시 어두운 배경이라 흰 스크롤바) */
      max-height: calc(6 * 1.6em);
      overflow-y: auto;
      overscroll-behavior: contain;
      scrollbar-width: thin;
      scrollbar-color: rgba(255, 255, 255, 0.4) transparent;
      &::-webkit-scrollbar {
        width: 5px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 999px;
        background-color: rgba(255, 255, 255, 0.4);
      }
    }
    & > .consult {
      margin-top: auto;
    }
  }
  & > .photo {
    position: relative;
    flex: 0 0 9.5rem;
    transition: opacity 0.3s;
  }
  @media ${device.sm} {
    &:hover {
      ${({ $history, theme }) =>
        $history &&
        `
        background-color: ${theme.colors.dark};
        border-color: ${theme.colors.dark};
        box-shadow: ${theme.shadow.md};
        & > .text {
          padding-right: 1.6rem;
          & > .title > .name { color: white; }
          & > .title > .grade { color: ${theme.colors.foreground.highlightinverted}; }
          & > .division { color: rgba(255, 255, 255, 0.7); }
          & > .contact { display: none; }
          & > .history { display: block; color: rgba(255, 255, 255, 0.9); }
          & > .consult > button { background-color: rgba(255, 255, 255, 0.14); color: white; }
          & > .consult > button:hover { background-color: ${theme.colors.accent}; }
        }
        & > .photo { display: none; }
      `}
    }
  }
  @media (max-width: 575px) {
    min-height: 10.5rem;
    & > .photo {
      flex-basis: 7rem;
    }
  }
`;
const Image = styled.img`
  position: absolute;
  height: 13.5rem;
  right: -0.5rem;
  bottom: 0;
  object-fit: contain;
  width: 10rem;
  @media (max-width: 575px) {
    height: 10rem;
    width: 7.5rem;
  }
`;
